// @flow

import { type Descriptor, createDescriptor } from '../../controls/router';

import {
  type SortParams,
  sortDescriptor,
  type PageParams,
  pageDescriptor,
  type LocationParams,
  locationDescriptor,
} from './sharedDescriptors';

export const developmentsFiltersDescriptor: Descriptor<{|
  ...SortParams,
  ...PageParams,
  ...LocationParams,
|}> = createDescriptor(pageDescriptor, sortDescriptor, locationDescriptor);
